import type { Components, Theme } from "@mui/material/styles";
import { autocompleteClasses } from "@mui/material/Autocomplete";
import { ChevronDownIcon, XIcon } from "../shared/icons";

export const MuiAutocomplete: Components<Theme>["MuiAutocomplete"] = {
  defaultProps: {
    popupIcon: <ChevronDownIcon size={14} color={(theme: Theme) => theme.palette.text.primary} />,
    clearIcon: <XIcon size={14} color={(theme: Theme) => theme.palette.text.primary} />,
  },
  styleOverrides: {
    listbox: ({ theme }) => ({
      fontSize: theme.typography.pxToRem(14),
      paddingTop: 0,
      paddingBottom: 0,

      [`.${autocompleteClasses.option}`]: {
        "&:hover": { backgroundColor: theme.palette.action.hover },
        "&.Mui-focused": { backgroundColor: theme.palette.action.focus },
        '&[aria-selected="true"]': { backgroundColor: theme.palette.action.selected },
        '&.Mui-focused[aria-selected="true"]': { backgroundColor: theme.palette.action.selected },
      },
    }),
    noOptions: ({ theme }) => ({ fontSize: theme.typography.pxToRem(14) }),

    paper: ({ theme }) => ({
      minWidth: "15rem",
      borderRadius: theme.shape.borderRadius,
      marginBlock: theme.spacing(0.5),
      border: `1px solid ${theme.palette.grey["300"]}`,
      boxShadow: theme.shadows[3],
    }),
    input: { paddingLeft: "0px !important", paddingTop: "2px !important", paddingBottom: "2px !important" },
    inputRoot: ({ theme }) => ({
      "& > svg": { marginRight: "6px" },
      "paddingLeft": "12px !important",
      "paddingRight": "18px !important",
      "borderRadius": theme.shape.borderRadius,
    }),
  },
};
